// vim: set ts=2 sw=2 et ft=javascript:
/*
 * Copyright (C) 2013 Minted Inc.
 *
 * All Rights Reserved
 */

/*
  UMD header generated via modularize.js at 2015-04-02T22:08:29.573Z
*/
var module; UMD(module, {
  'minted:m': ['M'],
  'minted:vendor/backbone-1.0.0.min': 'Backbone',
  'minted:vendor/underscore-1.8.2.min': '_'
})(this, function (m_module, Backbone, _) {

var M = m_module.M;

"use strict";

  M.Model = M.Model || {};
  M.Model.DeliveryEstimator = M.Model.DeliveryEstimator || {};

  /**
   * PO model for the new delivery estimator javascript api library
   */
  M.Model.DeliveryEstimator.PO = Backbone.Model.extend({

    orderedDates: [
      'ordered_on',
      'ordered_on_date',
      'proof_created_on',
      'proof_accepted_on',
      'started_printing_on',
      'finished_printed_on',
      'shipped_on',
      'delivered_on'
    ],

    defaults: function() {
      return {
        'ordered_on': null,
        'ordered_on_date': null,
        'proof_created_on': null,
        'proof_created_on_date': null,
        'proof_accepted_on': null,
        'proof_accepted_on_date': null,
        'started_printing_on': null,
        'started_printing_on_date': null,
        'finished_printed_on': null,
        'finished_printed_on_date': null,
        'shipped_on': null,
        'shipped_on_date': null,
        'delivered_on': null,
        'delivered_on_date': null,
        'po_state': null,
        'fulfiller_id': null,
        'is_rush': false,
        'shipping_method': null,
        'line_items': []
      };
    },

    initialize: function() {
      this.bind("change", function(model, options) {
        var changedAttributes = model.changedAttributes();
        // If nothing changed, do nothing.
        if (!changedAttributes) {
          return;
        }

        // If exactly one key has changed and it is a date, we want to clear all
        // dates ahead of it.
        var changedKeys = _(changedAttributes).keys();
        if (changedKeys.length == 1 &&
            _(model.orderedDates).contains(changedKeys[0])) {
          model.clearDatesAfter(changedKeys[0]);
        }
      });
    },

    /**
     * Given a date attribute name, clear all dates that come after it.
     *
     * This is useful for modifying one date in the EstimatorPO, while at the
     * same time clearing out all dates that come after it so they can be
     * recomputed by the API.
     */
    clearDatesAfter: function(changedAttribute) {
      var i = _(this.orderedDates).indexOf(changedAttribute);
      if (i >= 0) {
        var datesToClear = this.orderedDates.slice(i+1);
        var clearedAttrs = {};
        _(datesToClear).each(function(attribute) {
          clearedAttrs[attribute] = null;
          clearedAttrs[attribute + '_date'] = null;
        });
        // Set with silent=true to avoid triggering 'clearDatesAfter' with these
        // changes.
        this.set(clearedAttrs, {silent: true});
      }
    },

    /**
     * Returns true if the PO contains items that have a customer facing proof.
     */
    hasCustomerFacingProof: function() {
      return this.get('has_customer_facing_proof');
    },

    /**
     * Returns true if the PO typically has a customer proof but currently
     * has a same day proofing SLA.
     */
    hasOrderCutoff: function() {
      return (this.hasCustomerFacingProof() &&
        this.get('proof_creation_days') === 0);
    },

    /**
     * Returns true if express service is selected for every item in the PO.
     */
    isExpressService: function() {
      var isExpressService = true;
      // If one item is not express service, return false.
      _(this.get('line_items')).each(function(lineItem) {
        if (!lineItem['is_express_service']) {
          isExpressService = false;
        }
      });
      return isExpressService;
    },

    /**
     * adds a single LineItem model
     */
    addItem: function(item) {
      this.attributes.line_items.push(item.toJSON());
    },

    /**
     * adds multiple LineItem models
     */
    addItems: function(items) {
      var that = this;

      _.each(items, function(item) {
        that.addItem(item);
      });
    },

    // Getters for the date attributes.
    // TODO: Override 'get' instead to avoid code duplication.
    getOrderedOn: function() {
      var orderedOn = this.get('ordered_on');
      if (orderedOn instanceof Date) {
        return orderedOn;
      } else if (orderedOn) {
        return new Date(orderedOn * 1000);
      } else {
        return null;
      }
    },

    getProofCreatedOn: function() {
      var proofCreatedOn = this.get('proof_created_on');
      if (proofCreatedOn instanceof Date) {
        return proofCreatedOn;
      } else if (proofCreatedOn) {
        return new Date(proofCreatedOn * 1000);
      } else {
        return null;
      }
    },

    /**
     * Returns a customer readible proofing time SLA.
     *
     * @return string
     */
    getProofCreationDaysMessage: function() {
      var days = this.get('proof_creation_days');

      // Same day proofing (0 days)
      var message = 'the day';

      // 24hr proofing (standard)
      if (days === 1) {
        message = 'one business day';
      }

      // More than one day proofing
      if (days > 1) {
        message = M.Number.intToWord(days) + ' business days';
      }

      return message;
    },

    getProofAcceptedOn: function() {
      var proofAcceptedOn = this.get('proof_accepted_on');
      if (proofAcceptedOn instanceof Date) {
        return proofAcceptedOn;
      } else if (proofAcceptedOn) {
        return new Date(proofAcceptedOn * 1000);
      } else {
        return null;
      }
    },

    getDeliveredOn: function() {
      var deliveredOn = this.get('delivered_on');
      if (deliveredOn instanceof Date) {
        return deliveredOn;
      } else if (deliveredOn) {
        var date = new Date(deliveredOn * 1000);
        return M.Date.getUTC(date);
      } else {
        return null;
      }
    },

    /**
     * Returns the JSON representation of the EstimatorPO, as expected by the
     * delivery estimator API.
     *
     * If a value is a JS Date object, converts the value to a UNIX timestamp.
     */
    toJSON: function () {
      var that = this;
      var json = Backbone.Model.prototype.toJSON.call(this);
      _(json).chain().keys().each(function(key) {
        var val = json[key];
        // if the key is a date, convert the date to a timestamp
        if (_(that.orderedDates).contains(key) && val && val.getTime) {
          json[key] = Math.round(val.getTime() / 1000);
        }
      });
      return json;
    }
  });

return {
};

});

